export default __webpack_public_path__ + "static/media/icon_scan.6a6ea3ca.png";